import TopRatedShows from "./TopRatedShows";

export default TopRatedShows;
